const getInitialState = () => {
	return [];
}
export function getQuestionPointTotal(q){
	var total = 0;
	if ( q.type === 'radio-grid' ){
		if( q.choices[q.selection] ){
			total += q.choices[q.selection].points;
		}
	} else {
		if ( q.selection.length > 0 ){
			q.selection.map( (choiceIndex) => {
				total += q.choices[choiceIndex].points;
			});
		}
	}
	return total;
}
export function getQuestionSelectedValue(q){
	if ( q.type === 'radio-grid' ){
		return q.choices && q.choices[q.selection] ? q.choices[q.selection].value : null;
	} else {
		return q.selection.map( choice_index => {
			return q.choices[choice_index].value
		})
	}
}
export default function questionsReducer(state = getInitialState(), action) {
	var newState;
	switch( action.type ){
		case 'questions/reset':
			newState = state.map( (q,i) => {
				q.selection = [];
				return q;
			});
			return newState;
		case 'questions/load':
			// any initial processing can go here
			newState = state.map( (q,i) => {
				if ( !q.selection ){
					if ( q.type === 'radio-grid' ){
						q.selection = null;
					} else {
						q.selection = [];
					}
				}
				q.index = i;
				q.choices.forEach( c => {
					c.points = parseInt( c.points );
					if ( !c.value ){
						c.value = '';
					}
				});
				return q;
			});
			return newState;
		case 'questions/question/setSelection':
			newState = [...state];
			var questionIndex = action.payload.question;
			var selection = action.payload.selection;
			newState[questionIndex] = {
				...state[questionIndex],
				selection: selection
			};
			return newState;
		default:
			return state;
	}
	return state;
}